import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyComponent } from './company.component';
import { VisionComponent } from './vision/vision.component';
import { LocationComponent } from './location/location.component';
import { TechnologyComponent } from './technology/technology.component';



@NgModule({
  declarations: [
    CompanyComponent, 
    VisionComponent, 
    LocationComponent, 
    TechnologyComponent],
  
    exports:[
    ],
    imports: [
    CommonModule
  ]
})
export class CompanyModule { }
